var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { styled as muiStyled } from "@mui/material/styles";
import { CircularProgress, Typography } from "@mui/material";
import { Publish, RotateLeft, PlayCircle, PauseCircle, StopCircle } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Dialog } from "@sequentech/ui-essentials";
import { Button, FilterButton, SelectColumnsButton, useRecordContext } from "react-admin";
import { EPublishActionsType, EPublishType } from "./EPublishType";
import { PublishStatus, ElectionEventStatus, nextStatus } from "./EPublishStatus";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { EPublishActions } from "@/types/publishActions";
import { VotingStatusChannel } from "@/gql/graphql";
import { EInitializeReportPolicy, EVotingPeriodEnd, EVotingStatus, } from "@sequentech/ui-core";
import { usePublishPermissions } from "./usePublishPermissions";
import PublishExport from "./PublishExport";
var PublishActionsStyled = {
    Container: styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: flex;\n        margin-bottom: 8px;\n        justify-content: flex-end;\n        width: 100%;\n    "], ["\n        display: flex;\n        margin-bottom: 8px;\n        justify-content: flex-end;\n        width: 100%;\n    "]))),
};
export var StyledStatusButton = muiStyled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &.MuiButtonBase-root {\n        line-height: 1 !important;\n    }\n\n    :disabled {\n        color: #ccc;\n        cursor: not-allowed;\n        background-color: #eee;\n    }\n"], ["\n    &.MuiButtonBase-root {\n        line-height: 1 !important;\n    }\n\n    :disabled {\n        color: #ccc;\n        cursor: not-allowed;\n        background-color: #eee;\n    }\n"])));
export var PublishActions = function (_a) {
    var _b;
    var ballotPublicationId = _a.ballotPublicationId, publishType = _a.publishType, type = _a.type, status = _a.status, kioskModeEnabled = _a.kioskModeEnabled, electionStatus = _a.electionStatus, electionPresentation = _a.electionPresentation, changingStatus = _a.changingStatus, onGenerate = _a.onGenerate, _c = _a.onPublish, onPublish = _c === void 0 ? function () { return null; } : _c, _d = _a.onChangeStatus, onChangeStatus = _d === void 0 ? function () { return null; } : _d, data = _a.data;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    var isGoldUser = authContext.isGoldUser, reauthWithGold = authContext.reauthWithGold;
    var canWrite = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_WRITE);
    var record = useRecordContext();
    var isVotingPeriodEndDisallowed = (electionPresentation === null || electionPresentation === void 0 ? void 0 : electionPresentation.voting_period_end) == EVotingPeriodEnd.DISALLOWED;
    var canChangeStatus = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_STATE_WRITE);
    // const [addWidget, setWidgetTaskId, updateWidgetFail] = useWidgetStore()
    var _e = useState(false), showDialog = _e[0], setShowDialog = _e[1];
    var _f = useState(""), dialogText = _f[0], setDialogText = _f[1];
    var _g = useState(null), currentCallback = _g[0], setCurrentCallback = _g[1];
    var _h = usePublishPermissions(), canPublishRegenerate = _h.canPublishRegenerate, canPublishStartVoting = _h.canPublishStartVoting, canPublishPauseVoting = _h.canPublishPauseVoting, canPublishStopVoting = _h.canPublishStopVoting, canPublishChanges = _h.canPublishChanges, showPublishColumns = _h.showPublishColumns, showPublishFilters = _h.showPublishFilters;
    var StatusIcon = function (_a) {
        var changingStatus = _a.changingStatus, Icon = _a.Icon;
        return changingStatus ? _jsx(CircularProgress, { size: 16 }) : _jsx(Icon, { width: 24 });
    };
    var IconOrProgress = function (_a) {
        var st = _a.st, Icon = _a.Icon;
        return nextStatus(st) === status && status !== PublishStatus.Void ? (_jsx(CircularProgress, { size: 16 })) : (_jsx(Icon, { width: 24 }));
    };
    var StatusButton = function (_a) {
        var st = _a.st, label = _a.label, onClick = _a.onClick, Icon = _a.Icon, disabledStatus = _a.disabledStatus, _b = _a.disabled, disabled = _b === void 0 ? false : _b, className = _a.className;
        return (_jsx(Button, __assign({ onClick: onClick, className: className, label: t(label), style: changingStatus || (disabledStatus === null || disabledStatus === void 0 ? void 0 : disabledStatus.includes(status))
                ? {
                    overflow: "hidden",
                    color: "#ccc",
                    cursor: "not-allowed",
                    backgroundColor: "#eee",
                    padding: "6px 16px",
                }
                : {
                    overflow: "hidden",
                    padding: "6px 16px",
                }, disabled: disabled || (disabledStatus === null || disabledStatus === void 0 ? void 0 : disabledStatus.includes(status)) || st === status + 0.1 }, { children: _jsx(IconOrProgress, { st: st, Icon: Icon }) })));
    };
    var openDialog = function (dialogText) {
        setDialogText(dialogText);
        setShowDialog(true);
    };
    // Handler for navigating after a re-authentication action.
    var reauthCallback = function (baseUrl, action) {
        if (publishType === EPublishType.Event) {
            var electionEventPublishTabIndex = localStorage.getItem("electionEventPublishTabIndex");
            baseUrl.searchParams.set("tabIndex", electionEventPublishTabIndex !== null && electionEventPublishTabIndex !== void 0 ? electionEventPublishTabIndex : "8");
        }
        else {
            var electionPublishTabIndex = localStorage.getItem("electionPublishTabIndex");
            baseUrl.searchParams.set("tabIndex", electionPublishTabIndex !== null && electionPublishTabIndex !== void 0 ? electionPublishTabIndex : "4");
        }
        sessionStorage.setItem(action, "true");
    };
    /**
     * Specific Handler for "Start Voting" Button:
     * Incorporates re-authentication logic for actions that require Gold-level permissions.
     */
    var handleChangeVotingPeriod = function (action, status, voting_channels) {
        var actionText = action === EPublishActions.PENDING_START_VOTING
            ? t("publish.action.startVotingPeriod")
            : action === EPublishActions.PENDING_STOP_VOTING
                ? t("publish.action.stopVotingPeriod")
                : t("publish.action.pauseVotingPeriod");
        var dialogMessage = isGoldUser()
            ? action === EPublishActions.PENDING_START_VOTING
                ? t("publish.dialog.startInfo")
                : action === EPublishActions.PENDING_STOP_VOTING
                    ? t("publish.dialog.stopInfo")
                    : t("publish.dialog.pauseInfo")
            : t("publish.dialog.confirmation", { action: actionText });
        openDialog(dialogMessage);
        setCurrentCallback(function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
            var baseUrl, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!!isGoldUser()) return [3 /*break*/, 2];
                        baseUrl = new URL(window.location.href);
                        reauthCallback(baseUrl, action);
                        return [4 /*yield*/, reauthWithGold(baseUrl.toString())];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        onChangeStatus(status, voting_channels);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error("Re-authentication failed:", error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); }; });
    };
    /**
     * Specific Handler for "Stop Kiosk Voting" Button:
     * Incorporates re-authentication logic for actions that require Gold-level permissions.
     */
    var handleStopKioskVoting = function () {
        var actionText = t("publish.action.stopKioskVotingPeriod");
        var dialogMessage = isGoldUser()
            ? t("publish.dialog.kioskStopInfo", { action: actionText })
            : t("publish.dialog.confirmation", { action: actionText });
        openDialog(dialogMessage);
        setCurrentCallback(function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
            var baseUrl, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!!isGoldUser()) return [3 /*break*/, 2];
                        baseUrl = new URL(window.location.href);
                        reauthCallback(baseUrl, EPublishActions.PENDING_STOP_KIOSK_ACTION);
                        return [4 /*yield*/, reauthWithGold(baseUrl.toString())];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        onChangeStatus(ElectionEventStatus.Closed, [VotingStatusChannel.Kiosk]);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        console.error("Re-authentication failed:", error_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); }; });
    };
    /**
     * Specific Handler for "Publish Changes" Button: Incorporates
     * re-authentication logic for actions that require Gold-level permissions.
     */
    var handlePublish = function (is_generate) {
        var actionText = t("publish.action.publish");
        var dialogMessage = isGoldUser()
            ? is_generate
                ? t("publish.dialog.info")
                : t("publish.dialog.publishInfo", { action: actionText })
            : t("publish.dialog.confirmation", { action: actionText });
        openDialog(dialogMessage);
        setCurrentCallback(function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
            var baseUrl, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!!isGoldUser()) return [3 /*break*/, 2];
                        baseUrl = new URL(window.location.href);
                        reauthCallback(baseUrl, EPublishActions.PENDING_PUBLISH_ACTION);
                        return [4 /*yield*/, reauthWithGold(baseUrl.toString())];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        onGenerate();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_3 = _a.sent();
                        console.error("Re-authentication failed:", error_3);
                        setDialogText(t("publish.dialog.errorReauth"));
                        setShowDialog(true);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); }; });
    };
    /**
     * Checks for any pending actions after the component mounts. If a pending
     * action is found, it executes the action and removes the flag. Except to
     * publish action, which is handled in the useEffect of the parent
     * component.
     */
    useEffect(function () {
        var executePendingActions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var isGold, pendingStart, pendingPause, pendingStop, pendingStopKiosk;
            return __generator(this, function (_a) {
                if (!record) {
                    return [2 /*return*/];
                }
                isGold = isGoldUser();
                pendingStart = sessionStorage.getItem(EPublishActions.PENDING_START_VOTING);
                if (pendingStart) {
                    isGold && onChangeStatus(ElectionEventStatus.Open);
                    sessionStorage.removeItem(EPublishActions.PENDING_START_VOTING);
                }
                pendingPause = sessionStorage.getItem(EPublishActions.PENDING_PAUSE_VOTING);
                if (pendingPause) {
                    isGold && onChangeStatus(ElectionEventStatus.Paused);
                    sessionStorage.removeItem(EPublishActions.PENDING_PAUSE_VOTING);
                }
                pendingStop = sessionStorage.getItem(EPublishActions.PENDING_STOP_VOTING);
                if (pendingStop) {
                    isGold && onChangeStatus(ElectionEventStatus.Closed, [VotingStatusChannel.Online]);
                    sessionStorage.removeItem(EPublishActions.PENDING_STOP_VOTING);
                }
                pendingStopKiosk = sessionStorage.getItem(EPublishActions.PENDING_STOP_KIOSK_ACTION);
                if (pendingStopKiosk) {
                    isGold && onChangeStatus(ElectionEventStatus.Closed, [VotingStatusChannel.Kiosk]);
                    sessionStorage.removeItem(EPublishActions.PENDING_STOP_KIOSK_ACTION);
                }
                return [2 /*return*/];
            });
        }); };
        executePendingActions();
    }, [isGoldUser, onChangeStatus, onGenerate, record]);
    var kioskVotingStarted = function () {
        var _a;
        return (kioskModeEnabled &&
            [EVotingStatus.OPEN, EVotingStatus.PAUSED].includes((_a = electionStatus === null || electionStatus === void 0 ? void 0 : electionStatus.kiosk_voting_status) !== null && _a !== void 0 ? _a : EVotingStatus.NOT_STARTED));
    };
    return (_jsxs(_Fragment, { children: [_jsx(PublishActionsStyled.Container, { children: _jsx("div", __assign({ className: "list-actions", style: {
                        display: "flex",
                        gap: 0,
                        alignItems: "center",
                        justifyContent: "flex-end",
                    } }, { children: type === EPublishActionsType.List ? (_jsxs(_Fragment, { children: [showPublishColumns ? _jsx(SelectColumnsButton, {}) : null, showPublishFilters ? _jsx(FilterButton, {}) : null, canChangeStatus && canPublishStartVoting && (_jsx(StatusButton, { onClick: function () {
                                    return handleChangeVotingPeriod(EPublishActions.PENDING_START_VOTING, ElectionEventStatus.Open);
                                }, label: t("publish.action.startVotingPeriod"), st: PublishStatus.Started, Icon: PlayCircle, disabledStatus: [
                                    PublishStatus.Stopped,
                                    PublishStatus.Started,
                                    PublishStatus.GeneratedLoading,
                                ], disabled: ((_b = record === null || record === void 0 ? void 0 : record.presentation) === null || _b === void 0 ? void 0 : _b.initialization_report_policy) ===
                                    EInitializeReportPolicy.REQUIRED &&
                                    !(record === null || record === void 0 ? void 0 : record.initialization_report_generated) })), canChangeStatus && canPublishPauseVoting && (_jsx(StatusButton, { onClick: function () {
                                    return handleChangeVotingPeriod(EPublishActions.PENDING_PAUSE_VOTING, ElectionEventStatus.Paused);
                                }, label: t("publish.action.pauseVotingPeriod"), st: PublishStatus.Paused, Icon: PauseCircle, disabledStatus: [
                                    PublishStatus.Void,
                                    PublishStatus.Paused,
                                    PublishStatus.Stopped,
                                    PublishStatus.Generated,
                                    PublishStatus.GeneratedLoading,
                                ] })), canChangeStatus && canPublishStopVoting && (_jsx(StatusButton, { onClick: function () {
                                    return handleChangeVotingPeriod(EPublishActions.PENDING_STOP_VOTING, ElectionEventStatus.Closed, [VotingStatusChannel.Online]);
                                }, label: t("publish.action.stopVotingPeriod"), st: PublishStatus.Stopped, Icon: StopCircle, disabledStatus: [
                                    PublishStatus.Void,
                                    PublishStatus.Stopped,
                                    PublishStatus.Generated,
                                    PublishStatus.GeneratedLoading,
                                ], disabled: isVotingPeriodEndDisallowed })), canChangeStatus && kioskModeEnabled && (_jsx(StyledStatusButton, __assign({ onClick: handleStopKioskVoting, className: "kioskMode", label: t("publish.action.stopKioskVotingPeriod"), disabled: changingStatus ||
                                    !kioskVotingStarted() ||
                                    isVotingPeriodEndDisallowed }, { children: _jsx(StatusIcon, { changingStatus: changingStatus, Icon: StopCircle }) }))), canWrite && canPublishChanges && (_jsx(StatusButton, { Icon: Publish, onClick: function () { return handlePublish(false); }, st: PublishStatus.Generated, label: t("publish.action.publish"), disabledStatus: [PublishStatus.Stopped] }))] })) : (_jsxs(_Fragment, { children: [canWrite && canPublishRegenerate && (_jsx("div", __assign({ className: "list-actions", style: { paddingTop: "4px" } }, { children: _jsx(StatusButton, { Icon: RotateLeft, disabledStatus: [], st: PublishStatus.Generated, label: t("publish.action.generate"), onClick: function () { return handlePublish(true); } }) }))), canWrite && (_jsx(PublishExport, { ballotPublicationId: ballotPublicationId }))] })) })) }), _jsx(Dialog, __assign({ handleClose: function (flag) {
                    if (flag && currentCallback) {
                        currentCallback(); // Execute the saved callback
                    }
                    setShowDialog(false); // Close the dialog
                    setCurrentCallback(null); // Reset the callback
                }, open: showDialog, title: t("publish.dialog.title"), ok: t("publish.dialog.ok"), cancel: t("publish.dialog.ko"), variant: "info" }, { children: _jsx(Typography, __assign({ variant: "body1" }, { children: dialogText })) }))] }));
};
var templateObject_1, templateObject_2;
